import { MILLIY_LADDER } from 'modules/resultView/categoryResult';
import { estimateCategoryScore } from 'modules/test/category-scoring';
import type { SubjectProgress } from 'modules/test/types';

/** What a Milliy subject's card and level panel say about the learner. Every field is something the learner earned or chose. */
export interface SubjectLevel {
  attempts: number;
  /** The test's own 0-100 score of the best attempt: not an official certificate score. */
  ball: number | null;
  /** The category's own grade of the best attempt (A+ … C); null under the 60% the lowest grade needs. */
  level: string | null;
  /** The grade the learner set as their goal for this subject; null when they set none. */
  goal: string | null;
  bestPercent: number | null;
  weakTopics: string[];
}

const LADDER_LABELS = MILLIY_LADDER.map((step) => step.label);

/** A stored goal grade as the ladder spells it: `A_PLUS` is "A+". Null for anything the ladder has no step for. */
export function goalStep(goalLevel: string | null): string | null {
  const label = goalLevel?.replace('_PLUS', '+') ?? null;
  return label && LADDER_LABELS.includes(label) ? label : null;
}

/**
 * The level of the best finished attempt, read with the same thresholds as the result page. Null when the learner
 * has neither an attempt nor a goal in the subject, so the card stays as it was.
 */
export function subjectLevel(progress: SubjectProgress | undefined): SubjectLevel | null {
  if (!progress) return null;
  const goal = goalStep(progress.goalLevel);
  if (progress.attempts === 0 && !goal) return null;
  const level =
    progress.bestPercent === null ? null : estimateCategoryScore({ category: 'milliy-sertifikat', percentage: progress.bestPercent }).scoreDisplay;
  return {
    attempts: progress.attempts,
    ball: progress.bestBall,
    level,
    goal,
    bestPercent: progress.bestPercent,
    weakTopics: progress.weakTopics.map((t) => t.topic),
  };
}
